module.exports = __webpack_public_path__ + "static/media/unibest-solution-img2.cbf6c164.png";